namespace Areas.Dialogs.Calendar {
    "use strict";

    let selectedDate;
    
    export class CalendarDialog extends Areas.BaseDialog {
        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("Calendar", closeHandler)
        }

        protected ok = (e: any) => {
            const data = { date: selectedDate };
            this.close(DialogResult.Ok, data); 
        }
    }

    export function calendarChanged(data) {
        selectedDate = data.value;
        $("#CalendarOkDialog").click();
       }

}
